import { bodyRegular } from '@monorepo/shared/styles/text';
import React, { useCallback, useRef } from 'react';
import styled from 'styled-components';
import { Button } from './Button/Button';

const StyledInputLabel = styled.div`
  ${bodyRegular}
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray666};
`;

const HiddenFileInput = styled.input`
  display: none;
`;

type FileInputProps = {
  inputLabel?: string;
  multiple?: boolean;
  accept?: string;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  buttonText: string;
  inputId: string;
};

export function FileInput({
  inputLabel,
  multiple = false,
  accept = 'application/pdf,image/jpeg,image/png',
  handleFileChange,
  buttonText,
  inputId,
}: FileInputProps) {
  const hiddenFileInput = useRef<HTMLInputElement | null>(null);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      handleFileChange(e);
      // Clear so re-selecting the same file after removing it from the list fires onChange again
      if (hiddenFileInput.current) {
        hiddenFileInput.current.value = '';
      }
    },
    [handleFileChange],
  );

  const fileInput = (
    <>
      <HiddenFileInput
        ref={hiddenFileInput}
        type="file"
        multiple={multiple}
        accept={accept}
        onChange={handleChange}
        id={inputId}
        aria-hidden
      />
      <label htmlFor={inputId}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => hiddenFileInput.current?.click()}
        >
          {buttonText}
        </Button>
      </label>
    </>
  );

  if (!inputLabel) {
    return fileInput;
  }

  return (
    <StyledInputLabel>
      {inputLabel}
      {fileInput}
    </StyledInputLabel>
  );
}
